export const colorways = {
  methods: {
    // process colorways
    processColorways(colorways) {
      // add catch for potentially undefined colorways
      if (colorways === undefined) {
        return [];
      }

      // first, we want to filter colorways to make sure that they all have some inventory
      const filteredColorways = colorways.filter(
        (colorway) =>
          colorway.inventoryCount > 0 || colorway.isBackOrdered === 1
      );

      // then use new color system if exists on colorway, or default to old one
      // (ideally we can ditch the old one altogether, eventually)
      filteredColorways.forEach((colorway) => {
        // if new system exists, use that value or swatch
        if (colorway.color && colorway.color.hexCode) {
          colorway.swatch = colorway.color.hexCode;
        } else {
          // else, default to old value and add '#'
          colorway.swatch = colorway.hexValue.includes('#') ? colorway.hexValue : `#${colorway.hexValue}`
        }
      });

      return filteredColorways;
    },
  },
};
